import { render, staticRenderFns } from "./SetupOverviewServer.vue?vue&type=template&id=7ffc3a65&scoped=true"
import script from "./SetupOverviewServer.vue?vue&type=script&lang=ts"
export * from "./SetupOverviewServer.vue?vue&type=script&lang=ts"
import style0 from "./SetupOverviewServer.vue?vue&type=style&index=0&id=7ffc3a65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffc3a65",
  null
  
)

export default component.exports